import axios from 'axios';
import {V1API} from "../../../_helpers/APIPath";
import {encode, decode} from "../../dataMagic";
import {populateStore, performNetworkCall, buildFormData} from "@/store/asyncHelper";


const keyList = {
    smsUpdate : 'PROJECT_UPDATE',
    smsDelete : 'PROJECT_DELETE'
};

const mutations = {};
const store = {};

populateStore(store, mutations, keyList, false);

export default {
    namespaced: true,
    state : {
        salesRep: [], 
        salesRep_paginated:[],
        salesRep_count:null,
        salesRep_details:{},

        submitLoading: false,
        submitError: false,
        submitSuccess: false,

        ...store
    },

    mutations : {
        ...mutations,
        SET_SALES_REP (state, salesRep) {
            state.salesRep = salesRep;
        },
        SET_SALES_REP_PAGINATED (state, {results, pg_count}) {
            state.salesRep_paginated = results;
            state.salesRep_count = pg_count;
        },
        SET_SALES_REP_DETAILS(state, details){
            state.salesRep_details = details;
        },

        SUBMIT_LOADING (state, loading) {
            state.submitLoading = loading;
        },

        SUBMIT_ERROR (state, hasError) {
            state.submitError = hasError;
        },

        SUBMIT_SUCCESS (state, success) {
            state.submitSuccess = success;
        }
    },

    actions: {
  
   
        async fetchSalesRep ({ commit }) {
            commit('SUBMIT_LOADING', true);
            commit('SUBMIT_ERROR', false);

            let config = {
                headers: {
                  Authorization: "Bearer " + localStorage.getItem("access_token"),
                }
            };

            try{
                let result = await axios.get(V1API.get_sales_rep_withoutpg, config);
                let response = result.data

                commit('SET_SALES_REP', response.data);

            } catch(error) {
                commit('SUBMIT_ERROR', true);
            }
            finally {
                commit('SUBMIT_LOADING', false);
            }
           
        },

        async fetchSalesRepPaginated ({ commit },payload) {
            commit('SUBMIT_LOADING', true);
            commit('SUBMIT_ERROR', false);

            let config = {
                headers: {
                  Authorization: "Bearer " + localStorage.getItem("access_token"),
                }
            };

             try{
                let params = new URLSearchParams();
        
                if (payload.perPage) params.append('count', payload.perPage);
                if (payload.currentPage) params.append('page', payload.currentPage);
                if (payload.search_term) params.append('search_term', payload.search_term);
            
            
           
                let url = V1API.get_sales_rep_paginated + '?' + params.toString();
                let result = await axios.get(url, config);
                const {results, pg_count} = result.data
                commit('SET_SALES_REP_PAGINATED', {results, pg_count});
                return result
                
            
            } catch(error) {
                commit('SUBMIT_ERROR', true);
            }
            finally {
                commit('SUBMIT_LOADING', false);
            }
           
        },

        async updateSalesRep ({commit, state, dispatch}, payload) {
            let response='';
            let config = {
                headers: {
                    Authorization: "Bearer " + localStorage.getItem("access_token"),
                  }
            };
            await performNetworkCall(
                commit,
                keyList.smsUpdate,
               
                async () => {
                    response= await axios.patch(V1API.edit_sales_rep+ payload.id + '/edit',payload.salesRep ,config).then(result=>{
                        let data=decode(result.data)
                        return data
                    })

                    dispatch('fetchCompanyPaginated',{perPage:payload.perPage,currentPage:payload.page,search_term:payload.search_term});

                }
            )
            return response
        },

        async deleteSalesRep ({commit, dispatch}, payload) {
            let config = {
                headers: {
                  Authorization: "Bearer " + localStorage.getItem("access_token"),
                }
            };

            let response = await axios.delete(V1API.delete_sales_rep + payload.item + '/delete', config).then(result=>{
                let data = result.data
                return data
            })
            
            dispatch('fetchCompanyPaginated',{perPage:payload.perPage,currentPage:payload.page,search_term:payload.search_term});
            
            return response
        },

        async addSalesRep ({commit, dispatch}, payload) {
            commit('SUBMIT_LOADING', true);
            commit('SUBMIT_ERROR', false);

            let config = {
                headers: {
                  Authorization: "Bearer " + localStorage.getItem("access_token"),
                },
            };

            try{
                let response = await axios.post(V1API.create_sales_rep, payload.salesRep, config).then(result=>{
                    let data = result.data
                    return data

                });

                commit('SUBMIT_SUCCESS', true);
                dispatch ('fetchSalesRepPaginated',{perPage:payload.perPage,currentPage:payload.page,search_term:payload.search_term})
                // dispatch ('fetchSalesRep')
                return response

            }catch (e) {
                commit('SUBMIT_ERROR', true);
            }finally {
                commit('SUBMIT_LOADING', false);
            }
        },

        async fetchSalesRepDetails ({ commit },payload) {
            commit('SUBMIT_LOADING', true);
            commit('SUBMIT_ERROR', false);

            let config = {
                headers: {
                  Authorization: "Bearer " + localStorage.getItem("access_token"),
                }
            };

            try{
                let result = await axios.get(V1API.salesRep_details +payload, config);
                let response = result.data

                commit('SET_SALES_REP_DETAILS', response.data);
                return response

            } catch(error) {
                commit('SUBMIT_ERROR', true);
            }finally {
                commit('SUBMIT_LOADING', false);
            }

            return response
        },

        
    },

    getters: {}
}
